import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ErrorService } from 'services/error-service';
import { ToastService } from 'services/toast-service';
import { DesignTypeSideRopeCombinationService } from 'services/design-type-side-rope-combination-service';

@autoinject
export class DesignTypeSideRopeCombinationDetail {
  private designTypeSideRopeCombination: Models.DesignTypeSideRopeCombination;

  private constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private designTypeSideRopeCombinationService: DesignTypeSideRopeCombinationService
  ) {}

  private activate(params) {
    this.designTypeSideRopeCombinationService
      .get(params.Id + '?$expand=DesignType')
      .then( (res) => {
        this.designTypeSideRopeCombination = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private updateDesignTypeSideRopeCombination() {
    this.designTypeSideRopeCombinationService
      .put(this.designTypeSideRopeCombination, this.designTypeSideRopeCombination.Id)
      .then((res) => {
        this.eventAggregator.publish('designTypeSideRopeCombinationListReset', 1);
        this.toastService.showSuccess('designTypeSideRopeCombination.updated');
        this.router.navigateToRoute('design-type-side-rope-combination-list');
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private deleteDesignTypeSideRopeCombination() {
    this.designTypeSideRopeCombinationService
      .delete(this.designTypeSideRopeCombination.Id)
      .then((res) => {
        this.eventAggregator.publish('designTypeSideRopeCombinationListReset', 1);
        this.toastService.showSuccess('designTypeSideRopeCombination.deleted');
        this.router.navigateToRoute('design-type-side-rope-combination-list');
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private gotoParentView() {
    this.eventAggregator.publish('designTypeSideRopeCombinationListReset', 1);
    this.router.navigateToRoute('design-type-side-rope-combination-list');
  }
}
